import { makeStyles } from "@material-ui/core";

export const useHiddenScrollbarStyles = makeStyles({
  hideScrollbar: {
    scrollbarWidth: "none" /* Firefox */,
    msOverflowStyle: "none" /* IE 10+ */,
    "&::-webkit-scrollbar": {
      display: "none" /* Safari and Chrome */,
    },
  },
});
